const onUploadVideoIntroduction = async (stateCtx, mutationCtx, newVideo) => {
    const { sessionId, socket, virtualEventUser } = stateCtx;

    socket.emit('updateData', {
        objectId: sessionId,
        virtualEventSession: {
            VirtualEventUsers: [
                {
                    id: virtualEventUser.data.id,
                    isPrerecording: true,
                    recordingInfo: newVideo,
                },
            ],
        },
    });
};

export default onUploadVideoIntroduction;
